import React from "react";
import PropTypes from "prop-types";

const IconWordResponsiveButton = ({ icon, text, onClick, className, disabled, ...rest }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md text-sm font-medium focus:outline-none transition-colors ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className || ""}`}
      {...rest}
    >
      {icon}
      <span className="hidden md:inline-block md:ml-2">{text}</span>
    </button>
  );
};

IconWordResponsiveButton.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default IconWordResponsiveButton;
